import React, { useState, useEffect } from "react";
import axios from "axios";
import { getAppointments } from "../../../backendServices/appointmentService";
import { Box } from "@mui/material";

import { t } from "i18next";

const UserDashboard = ({ token }) => {
  // const { user, login, logout } = useAuth();

  const [appointments, setAppointments] = useState([]);
  // const [editAppointment, setEditAppointment] = useState(null);

  useEffect(() => {
    fetchAppointments();
  }, [token]);

  const fetchAppointments = async () => {
    // window.location.reload();
    try {
      const response = await getAppointments(token);
      console.log("fetchAppointments => user dashboard: ", response.data);
      setAppointments(response.data.appointments);
    } catch (error) {
      console.error("Failed to fetch appointments", error);
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        minHeight: "100vh",
        // p: 3,
        // pt: 12,
      }}
    >
      <div>
        <div>{/* <Appointments token={token} /> */}</div>
        <div>
          {/* <h2>Appointments</h2> */}
          <div className="row">
            {appointments && appointments.length > 0 ? (
              appointments?.map((appointment) => (
                <div key={appointment.id} className="col-md-3 mb-4">
                  <div
                    className="card"
                    // style={
                    //   appointment.status === "pending"
                    //     ? { backgroundColor: "#ff6b6b" }
                    //     : { backgroundColor: "#48dbfb" }
                    // }
                  >
                    <div className="card-body">
                      <h5 className="card-title">{appointment.service}</h5>
                      <p className="card-text">
                        {t("book_no")} : {appointment.id} <br />
                        {t("date")} : {appointment.book_date} <br />
                        {t("time")} : {appointment.time} <br />
                        {/* {t("book_status")} : {appointment.status} <br /> */}
                      </p>
                      <p
                        className="card-text"
                        style={
                          appointment.status === "pending"
                            ? { color: "#d63031" }
                            : { color: "#00b894" }
                        }
                      >
                        {t("book_status")} : {appointment.status} <br />
                      </p>
                      {/* <button className="btn btn-danger">
                        Cancel Appointment
                      </button> */}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              // Message to display if no appointments are available
              <p>No appointments available.</p>
            )}
          </div>
        </div>

        {/* {editAppointment && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            updateAppointment(editAppointment.id);
          }}
        >
          <h3>Edit Appointment</h3>
          <input
            type="text"
            value={editAppointment.service}
            onChange={(e) =>
              setEditAppointment({
                ...editAppointment,
                service: e.target.value,
              })
            }
            required
          />
          <input
            type="date"
            value={editAppointment.date}
            onChange={(e) =>
              setEditAppointment({ ...editAppointment, date: e.target.value })
            }
            required
          />
          <input
            type="time"
            value={editAppointment.time}
            onChange={(e) =>
              setEditAppointment({ ...editAppointment, time: e.target.value })
            }
            required
          />
          <button type="submit">Save Changes</button>
        </form>
      )} */}
      </div>
    </Box>
  );
};

export default UserDashboard;
